import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { VariantOperationAdapter } from './dto/varient-operation.adapter';
import { VariantOperationRepository } from './repository/variant-operation.repository';
import { VariantOperation } from './variant-operation.entity';
import { VariantOperationsController } from './variant-operations.controller';
import { VariantOperationsService } from './variant-operations.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([VariantOperationRepository]),
  ],
  controllers: [VariantOperationsController],
  providers: [VariantOperationsService,ApplicationExceptionHandler,VariantOperationAdapter,SaleOrderService],
  exports:[VariantOperationsService]
})
export class VariantOperationsModule {}
